import { apiRequest } from "@services/apiClient";

export const buildQuery = (params = {}) => {
  const pairs = Object.entries(params)
    .filter(([, v]) => v !== null && v !== undefined && v !== "" && v !== false)
    .map(([k, v]) => `${k}=${encodeURIComponent(v === true ? "true" : v)}`);
  return pairs.length ? `?${pairs.join("&")}` : "";
};

export const listRuns = ({ clinicId, status, onlyFailed } = {}) =>
  apiRequest({
    method: "GET",
    endpoint: `/agent-sim/runs${buildQuery({ clinic_id: clinicId, status, only_failed: onlyFailed })}`,
  });

export const getRun = (id) =>
  apiRequest({ method: "GET", endpoint: `/agent-sim/runs/${id}` });

export const createRun = ({ clinicId, purpose, mode = "live" }) =>
  apiRequest({ method: "POST", endpoint: "/agent-sim/runs", body: { clinic_id: clinicId, purpose, mode } });

export const listScenarios = ({ clinicId, purpose }) =>
  apiRequest({
    method: "GET",
    endpoint: `/agent-sim/scenarios${buildQuery({ clinic_id: clinicId, purpose })}`,
  });

export const createScenario = (payload) =>
  apiRequest({ method: "POST", endpoint: "/agent-sim/scenarios", body: payload });

export const updateScenario = (id, payload) =>
  apiRequest({ method: "PATCH", endpoint: `/agent-sim/scenarios/${id}`, body: payload });

export const deleteScenario = (id) =>
  apiRequest({ method: "DELETE", endpoint: `/agent-sim/scenarios/${id}` });

export const regenerateScenarios = ({ clinicId, purpose }) =>
  apiRequest({ method: "POST", endpoint: "/agent-sim/scenarios/regenerate", body: { clinic_id: clinicId, purpose } });
